/** Human-readable payment status_reason from poll/TTL / cancel paths. */
export function paymentStatusReasonLabel(reason?: string | null): string | null {
  if (!reason) return null;
  const r = reason.trim();
  const map: Record<string, string> = {
    user_cancelled: 'Отменён пользователем',
    pending_ttl_expired: 'Таймаут pending (не оплачен вовремя)',
    yookassa_canceled: 'Отмена в YooKassa',
    yookassa_cancelled: 'Отмена в YooKassa',
  };
  if (map[r]) return map[r];
  if (r.startsWith('yookassa_')) return `YooKassa: ${r.slice('yookassa_'.length)}`;
  return r;
}
